import { all /*put, takeLatest, select*/ } from 'redux-saga/effects';

//import store from '../../../store';

export default all([
  // 1º parametro é qual ação queremos ouvir
  // 2º parametro é qual action queremos disparar
]);
